module.exports = __webpack_public_path__ + "img/bank-05-hana.975bbb1a.svg";